var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rb-modal",
    {
      class: _vm.$style.dialog,
      attrs: { options: _vm.modalOptions },
      on: {
        cancel: function ($event) {
          return _vm.cancel()
        },
        hide: function ($event) {
          return _vm.submit()
        },
      },
    },
    [
      _c("span", { attrs: { slot: "header" }, slot: "header" }, [
        _vm._v("Send Final Agreements"),
      ]),
      _c("div", { attrs: { slot: "body" }, slot: "body" }, [
        _c("p", { class: _vm.$style.paragraph }, [
          _vm._v(
            " You have chosen to send Final Agreements to " +
              _vm._s(_vm.report.bids.length) +
              " bids as a bulk action. "
          ),
        ]),
        _c("p", { class: _vm.$style.paragraph }, [
          _vm._v(
            " This operation will set all rates as Accepted in selected bids that do not have accepted bids set. "
          ),
        ]),
        _c("p", { class: _vm.$style.paragraph }, [
          _vm._v(" Are you sure you want to continue? "),
        ]),
      ]),
      _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
        _vm.allowSkipEmails
          ? _c(
              "button",
              {
                staticClass: "rbButton",
                on: {
                  click: function ($event) {
                    return _vm.submit({ skipEmails: true })
                  },
                },
              },
              [_vm._v("Yes (NO EMAILS)")]
            )
          : _vm._e(),
        _c(
          "button",
          {
            staticClass: "rbButton",
            on: {
              click: function ($event) {
                return _vm.cancel()
              },
            },
          },
          [_vm._v("No")]
        ),
        _c(
          "button",
          {
            staticClass: "rbButton mainButton",
            on: {
              click: function ($event) {
                return _vm.submit()
              },
            },
          },
          [_vm._v("Yes")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }